import { endsWith } from 'lodash';
import { CCIS_IMAGE } from '../constants/defaults.js';

export function ccisImage({ 
  baseUrl=CCIS_IMAGE.baseUrl,
  token=CCIS_IMAGE.token, 
  vehicle=CCIS_IMAGE.vehicle,
  width=CCIS_IMAGE.width,
  height=CCIS_IMAGE.height,
  angle=CCIS_IMAGE.angle,
  quality=CCIS_IMAGE.quality,
  type=CCIS_IMAGE.type,
  color=CCIS_IMAGE.color,
  upholstery=CCIS_IMAGE.upholstery,
  countryCode=CCIS_IMAGE.countryCode,
  options,
  wheel,
  wheelType
  } = {}) 
{
  const imageUrl = (props={}) => 
    `${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}l1-images/resize/ccis/` +
    `${props.width || width}x${props.height || height}/` +
    `zip/${props.countryCode || countryCode}/` +
    `product-token/${props.token || token}/` +
    `vehicle/${props.vehicle || vehicle}/` +
    `${(options || props.options) ? 'options/' + (props.options || options) + '/' : ''}` +
    `${(wheel || props.wheel) ? (wheelType === 'option' || props.wheelType === 'option' ? 'options/' : 'accessories/') + (props.wheel || wheel) + '/' : ''}` +
    `padding/50,50,50,50/` +
    `image-quality/${props.quality || quality}/` +
    `${props.type || type}-${props.angle || angle}_${props.color || color}` +
    `${props.upholstery || upholstery ? '_' + (props.upholstery || upholstery) : ''}.png`;

  const loadImage = url => new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', () => resolve(img));
    img.addEventListener('error', (err) => reject(err));
    img.src = url;
  });

  const loadMultipleImages = urls => {
    const promisesArray = [];
    if (Array.isArray(urls)) {
      urls.map(url => {
        promisesArray.push(loadImage(url));
      })
    } 
    return Promise.all(promisesArray);
  };

  const getImgUrl = props => imageUrl(props);
  
  function getLazyImgWithPlaceholderImgUrl(placeholderWidth=50, placeholderHeight=50, placeholderQuality=10) {
    const lowResPlaceholderImgUrl = imageUrl({width: placeholderWidth, height: placeholderHeight, quality: placeholderQuality});
    return {
      imgUrl: imageUrl(),
      placeholderImgUrl: lowResPlaceholderImgUrl, 
      lazyImgPromise: loadImage(imageUrl())
    };
  };

  function loadRangeOfAngles(range) {
    const angleRange = Array.isArray(range) ? range : range === 'all' ? [0, 36] : false;
    const imagesArray = [];

    if (angleRange) {
      for(let i=angleRange[0]; i<angleRange[1]; i++) { 
        const angledImgUrl = imageUrl({angle: i});
        imagesArray.push(angledImgUrl);
      }
    };

    return loadMultipleImages(imagesArray);
  };

  return {
    getImgUrl,
    getLazyImgWithPlaceholderImgUrl,
    loadRangeOfAngles
  };
};